<!-- src/App.vue -->
<template>
  <Particles />
  <h1 class="mb-5">Choose your plan</h1>
  <div class="plans-min-height">
    <Plans />
  </div>
  <div class="py-5 my-5 m-md-0 p-md-0">
    <Pill />
  </div>
  <div class="container mt-5 py-5">
    <div class="row">
      <div class="col-12">
        <h2>How it works</h2>
        <p>
          Signing up for Grapefroot is really simple! We don't run any credit checks so you are guaranteed to be
          accepted. Simply sign up now , we will post out your SIM and then activate your SIM using our easy to follow
          process
        </p>
      </div>
    </div>
  </div>
  <HowItWorks />
</template>

<script setup>
import Plans from "../components/Plans";
import Pill from "../components/Pill";
import HowItWorks from "../components/HowItWorks";
import Particles from "../components/Particles"

import { useHead } from '@vueuse/head'

useHead({
  title: 'Grapefroot | Plans',
  meta: [
    {
      name: 'description',
      content: 'Meta description',
    },
  ],
})


</script>

<style lang="scss" scoped>
h1 {
  color: var(--lime);
  text-align: center;
  font-size: 2.1em;
  filter: drop-shadow(var(--box-shadow));

  @media only screen and (min-width: 600px) {
    font-size: 3em;
  }
}

h2 {
  color: var(--banana);
  text-align: center;
  font-size: 1.9em;
  filter: drop-shadow(var(--box-shadow));

  @media only screen and (min-width: 600px) {
    font-size: 2.1em;
  }
}

p {
  text-align: center;
  color: var(--primary);
  filter: drop-shadow(var(--box-shadow));
}

.plans-min-height {
  min-height: 300px;
}

</style>
